import { render } from "./ListPillow.vue?vue&type=template&id=fa358700"
import script from "./ListPillow.vue?vue&type=script&lang=js"
export * from "./ListPillow.vue?vue&type=script&lang=js"

import "./ListPillow.vue?vue&type=style&index=0&id=fa358700&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__